export const productHeroObj = {
  lightBg: false,
  lightText: true,
  lightTextDesc: true,
  headline: "Happiness Multiplies When Shared",
  description: "",
};

export const productProductsObj = {
  10: {
    name: "Fruit Snacks",
    ingredients:
      "Sugar, Glucose Syrup, Organic Apple Juice Concantrate(%10), Modified Potato Starch, Acidity Regulator (Citrit, Acid, Malic Acid), Flavourings (Strawberry, Pomegranate, Apple, Peach, Melon, Orange), Spirulina Extract, Beet Root Juice Concentrate, Natural Colours (Turmeric, Anthocyanin Beta Carotene)",
    desc: "Herby Fruit Snacks, made with the real flavors of Apple, Strawberry, Orange, Pomegranate, Melon and Peach fruits, has been carefully prepared for you.",
    img: "/images/redherby.png",
    backImg: ["/images/redherbyback.png"],
  },
  11: {
    name: "Sour Fruit Snacks",
    ingredients:
      "Sugar, Glucose Syrup, Organic Apple Juice Concantrate(%10), Modified Potato Starch, Acidity Regulator (Citrit, Acid, Malic Acid), Flavourings (Strawberry, Pomegranate, Apple, Peach, Melon, Orange), Spirulina Extract, Beet Root Juice Concentrate, Natural Colours (Turmeric, Anthocyanin Beta Carotene)",
    desc: "Made with the real flavors of Apple, Strawberry, Orange, Pomegranate, Melon and Peach fruits, Herby Fruit Snacks has been carefully prepared for you with its sour flavor.",
    img: "/images/yellowherby.png",
    backImg: ["/images/yellowherbyback.png"],
  },
  12: {
    name: "Mango Sour Belts",
    ingredients:
      "Sugar,Glucose Syrup, Flour (Wheat), Malic Acid, Palm Oil, Corn Starch Modified, Apple Juice Concentrate, Citric Acid, Natural Flavours, Monogliserid, Fruit & Vegatable Juice Concentrate (Black Carrot,Blueberry), Natural Colors (Turmeric, Spirulina Extract, Paprika Extract). Contains Wheat Gluten",
    img: "/images/mango.png",
    backImg: ["/images/mango_ingredients.png","/images/mango2.jpg", "/images/mango3.jpg", "/images/mango4.jpg", "/images/mango5.jpg", "/images/mango6.jpg"],
  },
  13: {
    name: "Rainbow Sour Belts",
    ingredients:
      "Sugar,Glucose Syrup, Flour (Wheat), Malic Acid, Palm Oil, Corn Starch Modified, Apple Juice Concentrate, Citric Acid, Natural Flavours, Monogliserid, Fruit & Vegatable Juice Concentrate (Black Carrot,Blueberry), Natural Colors (Turmeric, Spirulina Extract, Paprika Extract). Contains Wheat Gluten",
    img: "/images/rainbow.png",
    backImg: ["/images/rainbow_ingredients.png","/images/rainbow2.jpg", "/images/rainbow3.jpg", "/images/rainbow4.jpg","/images/rainbow5.jpg"],
  },
};
